import { BrandFavicon } from '../components/BrandFavicon';
import { SourceDisplayTypeBadge } from '../components/sources/SourceDisplayTypeBadge';
import { getHelpHtml } from '../utils/help/help-content';
import {
  formatSourceCount,
  formatSourceDate,
  formatSourcePercent,
  sourceDisplayLabel
} from '../utils/source-insights';
import type { SourceInsightsDomainItem } from '../types';

function columnHelp(key: string): string | undefined {
  return getHelpHtml(key) || undefined;
}

export const sourceDomainsColumns = [
  {
    field: 'host',
    type: 'string',
    title: 'منبع',
    tooltip: columnHelp('sections.identified_sources_table'),
    minWidth: 220,
    flex: 1,
    cellRenderer: (params: { data: SourceInsightsDomainItem }) => {
      const row = params.data;
      if (!row) return null;
      const label = sourceDisplayLabel(row.host, row.displayName);
      const showHostSubtitle =
        Boolean(row.displayName?.trim()) &&
        row.displayName.trim().toLowerCase() !== row.host.toLowerCase();

      return (
        <div className="d-flex align-items-center gap-2 h-100">
          <BrandFavicon host={row.host} name={label} size="sm" />
          <div className="min-w-0 lh-sm">
            <div className="fw-medium text-1000 text-truncate">{label}</div>
            {showHostSubtitle ? (
              <div className="fs--2 text-400 text-truncate">{row.host}</div>
            ) : null}
          </div>
        </div>
      );
    }
  },
  {
    field: 'displayType',
    type: 'string',
    title: 'نوع',
    tooltip: columnHelp('sections.source_types'),
    width: 130,
    cellRenderer: (params: { value: string }) => (
      <div className="w-100 d-flex h-100 align-items-center">
        <SourceDisplayTypeBadge type={params.value} />
      </div>
    )
  },
  {
    field: 'usedPercent',
    type: 'number',
    title: 'استفاده‌شده',
    tooltip: columnHelp('tables.used_percent'),
    width: 130,
    cellRenderer: (params: { value: number }) => formatSourcePercent(params.value)
  },
  {
    field: 'citations',
    type: 'number',
    title: 'Citationها',
    tooltip: columnHelp('metrics.total_citations'),
    width: 130,
    cellRenderer: (params: { value: number }) => formatSourceCount(params.value)
  },
  {
    field: 'avgCitations',
    type: 'number',
    title: 'میانگین Citation',
    tooltip: columnHelp('tables.avg_citations'),
    width: 150,
    cellRenderer: (params: { value: number }) => formatSourceCount(params.value)
  },
  {
    field: 'aiResponses',
    type: 'number',
    title: 'پاسخ‌های AI',
    tooltip: columnHelp('tables.ai_responses'),
    width: 130,
    cellRenderer: (params: { value: number }) => formatSourceCount(params.value)
  },
  {
    field: 'lastSeenAt',
    type: 'string',
    title: 'آخرین مشاهده',
    tooltip: columnHelp('tables.last_seen'),
    width: 160,
    cellRenderer: (params: { value: string | null }) => formatSourceDate(params.value)
  }
];
